import { render, staticRenderFns } from "./PricePreSaleCard.vue?vue&type=template&id=67b1c1ef&scoped=true&"
import script from "./PricePreSaleCard.vue?vue&type=script&lang=js&"
export * from "./PricePreSaleCard.vue?vue&type=script&lang=js&"
import style0 from "./PricePreSaleCard.vue?vue&type=style&index=0&id=67b1c1ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b1c1ef",
  null
  
)

export default component.exports